module.exports = __webpack_public_path__ + "static/media/Redondela.66a919cd.jpg";